export * from './tabs.component';
